<template>
  <transition name="FadeRight" v-bind="$attrs" v-on="hooks">
    <slot></slot>
  </transition>
</template>

<script>
export default {
  name: "FadeRight",
  props: {
    duration: {
      type: Number,
      default: 600
    },
    delay: {
      type: Number,
      default: 300
    }
  },
  computed: {
    hooks() {
      return {
        beforeEnter: this.setTiming,
        afterEnter: this.cleanUpTiming,
        beforeLeave: this.setTiming,
        afterLeave: this.cleanUpTiming,
        ...this.$listeners
      };
    }
  },
  methods: {
    setTiming(el) {
      el.style.transitionDuration = `${this.duration}ms`;
      el.style.transitionDelay = `${this.delay}ms`;
    },
    cleanUpTiming(el) {
      el.style.transitionDuration = "";
      el.style.transitionDelay = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.FadeRight-enter-active,
.FadeRight-leave-active {
  transition: opacity 0.6s ease-in-out 0.75s, transform 0.75s ease-out 0.75s;
}

.FadeRight-enter {
  opacity: 0;
  transform: translateX(-32px);
}

.FadeRight-leave-to {
  opacity: 0;
  transform: translateX(32px);
}
</style>
